import { Col, Container, Row } from "reactstrap";
import Description from "./Description";

const Why = () => {

  const listWhy = [
    { icon:"assets/images/icon1.webp", title: "Skill Praktis yang Siap Kerja", body: "Materi dikurasi bareng industri supaya kamu bukan cuma paham teori, tapi langsung siap kerja setelah lulus."},
    { icon:"assets/images/icon2.webp", title: "Lokasi di Melbourne - Kota Pelajar Favorit Dunia", body: "Melbourne dikenal sebagai salah satu kota paling nyaman & seru buat mahasiswa internasional dengan kultur hidup yang lengkap."},
    { icon:"assets/images/icon3.webp", title: "Komunitas Internasional + Support Services", body: "Support service lengkap dari mulai orientation sampai career support biar kamu betah dan sukses di sini."},
    { icon:"assets/images/icon4.webp", title: "Biaya Kuliah yang Masih Masuk Akal", body: "Biaya studinya lebih bersahabat dibanding universitas top Australia, plus ada opsi beasiswa!"},
  ]

  return (
    <section className="section" id="why">
      <Container>
        <Row className="why-wrapper flex-lg-row gap-4">
        <Description />
          <Col>
            <img 
              src="assets/images/img-why.webp" 
              alt="melbourne-polytechnic-sign-and-students-of-melbourne-polytechnic's" 
              className="img-fluid"
            />          
          </Col>
          <Col>
            <h1 className="mb-3"><b>Kenapa Pilih Melbourne Polytechnic?</b></h1>
            <div className="mb-3 mb-md-5">
              {listWhy.map((item, id) => (
                <div key={id} className="d-flex text-start gap-2">
                  <div>
                    <img 
                      src={item.icon}  
                      alt={`icon-${item.title}`} 
                      className="why-icon"
                    />              
                  </div>
                  <div>
                      <span className="fw-bold">{item.title}</span>
                      <p className="fw-normal">{item.body}</p>
                  </div>                
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
      <div className="nominee-wrapper">
        <Container>
        <img src="assets/images/nominee2.svg" alt="winner-large-training-provider-of-the-year-2024" className="img-fluid" />
        <img src="assets/images/nominee3.svg" alt="tave-victoria" className="img-fluid" />
        <img src="assets/images/nominee1.svg" alt="victorian-training-awards" className="img-fluid" />          
        </Container>
      </div>       
    </section>
  );
};

export default Why;